module.exports = __webpack_public_path__ + "static/media/stripe.e5203c09.png";